module.exports = __webpack_public_path__ + "img/174.5b11bea.svg";